import React from 'react';
import { message } from 'antd';
import { WeaTools, WeaLocaleProvider, WeaDialog } from 'ecCom';
import { getCookieValue, getLSValue, setLSValue, initLSValue ,doEvent} from './loginutil';
import { toJS } from 'mobx';
const getLabel = WeaLocaleProvider.getLabel;
import E9Login from './e9login/E9Login';
import './WeaLoginPop.css';

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {  
        visible: false, 
        dialoading:false,
        loading: true,
        updatestatus : '',
        casstatus:'',
        afterLoginRenderEventStatus : false,
        multiLangs:getLSValue('login', 'multiLangs') || [],
        qrcodeValidTime : 30,
        qrcodeReqTime : 1,
        qrcodeIsInvalid : false,
        customloading : false,
        queryParams : WeaTools.ls.getJSONObj('login-pop-params')||{},
        locationparams:WeaTools.ls.getJSONObj('login-pop-window.location')||{},
        loginFormDataLoading :false,
        dynamicPasswordTime : 0,
        dynamicPasswordInterval : 0,
        seriesnum_ : 0,
        emobileDownloadUrl : '',
        loginstate : Object.assign(
            {},
            {
              isLogging: false,
              hasMultiLang: false,
              multiLangVisible: false,
              loginFormItems: [],
              loginFormHiddenItems: [],
              loginSetting: {},
              qrCode: {},
              validateCode: '/weaver/weaver.file.MakeValidateCode?seriesnum_=0',
              labelInfo: [],
            },
            Object.assign({}, getLSValue('login', 'loginCache'), {
              loginType: getLSValue('login', 'loginType') || 'form',
              langId: getLSValue('login', 'langId') || '',
              langText: getLSValue('login', 'langText') || '',
              isRememberAccount: getLSValue('login', 'isRememberAccount') || getCookieValue('isRememberAccount') || false,
              isRememberPassword: getLSValue('login', 'isRememberPassword') || getCookieValue('isRememberPassword') || false,
              cacheAccount: getLSValue('login', 'cacheAccount') || getCookieValue('cacheAccount') || '',
              cachePassword: getLSValue('login', 'cachePassword') || getCookieValue('cachePassword') || '',
            }),
          ),
    };
    this.loginsetState = this.loginsetState.bind(this);
    this.getLoginForm = this.getLoginForm.bind(this);
    this.getLoginInfo = this.getLoginInfo.bind(this);
    this.getMultiLangs = this.getMultiLangs.bind(this);
    this.setStateAndCache = this.setStateAndCache.bind(this);
    this.doAfterLoginRenderEvent = this.doAfterLoginRenderEvent.bind(this);
    this.onPasswordForget = this.onPasswordForget.bind(this);
    this.onRememberChange = this.onRememberChange.bind(this);
    this.onValidateCodeChange = this.onValidateCodeChange.bind(this);
    this.getDynamicPassword = this.getDynamicPassword.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.onQCLoginStart = this.onQCLoginStart.bind(this);
    this.onQCLoginEnd = this.onQCLoginEnd.bind(this);
    this.onQCLogin =this.onQCLogin.bind(this);
  }
 
  loginsetState(newstate){
    this.setState({ loginstate: Object.assign({}, this.state.loginstate, newstate)});
  }

  setStateAndCache(key, value) {
    this.loginsetState({ [key]: value });
    setLSValue('login', key, value);
  }
  componentWillMount() {
    const { visible } = this.props;
    if(window.doLoginAction){
      if (visible) {
        window.hasloginpop=true;
        this.onShow();
      }
    }else{
      loadjs.isDefined("login-pop") ? loadjs.ready('login-pop',()=>{
        }) : loadjs(['/spa/hrm/staticLoginNew/loginNew.js'],'login-pop',()=>{
          if (visible) {
            window.hasloginpop=true;
            this.onShow();
          }
        })
      }
    }
    



  onShow = () => {
    this.setState({ visible: true, dialoading: true });  
    let params=this.state.queryParams;
    this.getLoginInfo(params);
  };

  doAfterLoginRenderEvent() {
    // 防止重复执行
    if (!this.state.afterLoginRenderEventStatus) {
      doEvent('afterLoginRender', () => (this.setState({  afterLoginRenderEventStatus: true })));
    }
  }

  getMultiLangs(params = {}) {
    WeaTools.callApi('/api/system/language/base/getActiveLanguage', 'GET', params).then((result) => {
        if (result.status == '1') {
            const { activeLanguageInfo, activeLanguageIds, languageIdentify, systemDefaultLang = {} } = result;
            this.setState({multiLangs:activeLanguageInfo})

            setLSValue('login', 'multiLangs', activeLanguageInfo);
            WeaTools.ls.set('activeLanguageIds', activeLanguageIds);
            WeaTools.ls.set('languageIdentify', languageIdentify);
            this.getLoginForm({langId: this.state.loginstate.langId });
          if (!this.state.loginstate.langId) {
            let language = {};
            for (let key in systemDefaultLang) {
              language = { id: key, language: systemDefaultLang[key] };
            }
            const { id: langId = '7', language: langText = '简体中文' } = language;
            this.loginsetState({ langId, langText });
            this.getLoginForm({ langId });
          }
        }
    });
  }

  getLoginInfo(params = {}, callBack) {
    this.setState({ updatestatus: '0',casstatus:'0' ,loading:true});  

    // 获取多语言
    this.getMultiLangs(params);

    WeaTools.callApi('/api/portal/login/logininfo', 'POST', params).then((result) => {
      // 缓存登录日期
      const date = new Date();
      const loginDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      WeaTools.ls.set('loginDate', loginDate);

      if (result.status != '2') {
        const {
            settingversion,
            id: templateId,
            templateType,
            loginSettingInfo = {},
            isRememberAccount,
            isRememberPassword,
            cacheAccount = '',
            cachePassword = '',
            emobileDownloadUrl,
        } = result;
        const { loginInfo = {} } = loginSettingInfo;
        const { showQrcode, qrcodeValidTime = 30, qrcodeReqTime = 1, defaultQrcode, onlyQrcode } = loginInfo;
         // 判断接口返回的设置版本和缓存的设置版本是否一致
         const _settingversion = getLSValue('login', 'settingversion');
         const _templateId = getLSValue('login', 'templateId');
         const isNewVersion = settingversion != _settingversion || templateId != _templateId;
 
         // 获取登录方式
         this.setState({qrcodeValidTime:qrcodeValidTime,qrcodeReqTime:qrcodeReqTime,emobileDownloadUrl:emobileDownloadUrl})
         let loginType = 'form';
         if (showQrcode) {
           if (onlyQrcode) {
             loginType = 'QRCode';
           } else {
             const _loginType = getLSValue('login', 'loginType') || '';
             loginType = _loginType || (defaultQrcode ? 'QRCode' : 'form');
           }
         }
         setLSValue('login', 'loginType', loginType);

         // 获取记住的账号和密码
         if (isRememberAccount != undefined) {
           setLSValue('login', 'isRememberAccount', isRememberAccount);
           setLSValue('login', 'isRememberPassword', isRememberPassword);
           setLSValue('login', 'cacheAccount', cacheAccount);
           setLSValue('login', 'cachePassword', cachePassword);
 
           this.loginsetState({ isRememberAccount, isRememberPassword, cacheAccount, cachePassword });
         }

         const state = Object.assign({}, result, { loginType });
         setLSValue('login', 'loginCache', state);
 
         if (isNewVersion) {
           setLSValue('login', 'settingversion', settingversion);
           setLSValue('login', 'templateId', templateId);
           setLSValue('login', 'templateType', templateType);
           setLSValue('login', 'loginBgImage', loginInfo.imgsrc);
           setLSValue('login', 'loginBgImageWidth', loginInfo.width);
           setLSValue('login', 'loginBgImageHeight', loginInfo.height);
           this.loginsetState(state);  
         }
       } else {
         message.error(result.errormsg);
       }
       if (callBack) {
            callBack();
        }
       this.setState({  loading: false,dialoading:false });
     });
  }

  // 获取登录表单
  getLoginForm(params = {}, callback) {
    const queryParams = this.state.queryParams;
    const { logintype = '1' } = queryParams;
    const { loginId = '', langId =  this.state.loginstate.langId } = params;
    if (langId) {
      window.doLoginAction &&
        window.doLoginAction('getLoginForm', {
          queryParams,
          logintype,
          loginid: loginId,
          langid: langId,
          callback: (result) => {
            const {
              hasMultiLang = false,
              loginFormItems = [],
              loginFormHiddenItems = [],
              loginSetting = {},
              qrCode = {},
            } = result;

            this.loginsetState({ hasMultiLang, loginFormItems, loginFormHiddenItems, loginSetting, qrCode });
            if (callback && typeof callback == 'function') {
              callback(result);
            }

            // 登录表单数据加载完成
            this.setState({loginFormDataLoading:true,dialoading:false})
          },
        });
    }
  }

  onPasswordForget(params = {}) {
    const { langId = this.state.loginstate.langId } = params;
    window.doLoginAction && window.doLoginAction('forgetPassword', { langid: langId });
  }

  onValidateCodeChange() {
    setTimeout(
      () =>
        this.loginsetState({
          validateCode: `/weaver/weaver.file.MakeValidateCode?seriesnum_=${++this.state.seriesnum_}`,
        }),
      50,
    );
  }
  
  onRememberChange(type, checked) {
    const { isRememberAccount, isRememberPassword } = this.state.loginstate;
    if (type == 'account') {
      this.loginsetState({
        isRememberAccount: checked,
        isRememberPassword: !checked ? checked : isRememberPassword,
      });
    } else if (type == 'password') {
      this.loginsetState({
        isRememberAccount: checked || isRememberAccount,
        isRememberPassword: checked,
      });
    }
  }

  getDynamicPassword() {
    const queryParams = this.state.queryParams;
    const { logintype = '1' } = queryParams;
    const { langId, loginSetting } = this.state.loginstate;

    window.doLoginAction &&
      window.doLoginAction('getDynamicPassword', {
        logintype,
        langid: langId,
        loginSetting,
        success: (params) => {
          const { validitySec = 60 } = params;
          this.setState({dynamicPasswordTime:validitySec})

          const _interval = setInterval(() => {
            const time = this.state.dynamicPasswordTime;
            if (time == 1) {
              window.clearInterval(this.state.dynamicPasswordInterval);
            }
            this.setState({dynamicPasswordTime:time - 1})
          }, 1000);
          this.setState({dynamicPasswordInterval:_interval})
        },
      });
  }

  onLogin() {
    const {queryParams,locationparams} = this.state;
    const { logintype = '1' } = queryParams;
    const { langId, langText, isRememberAccount, isRememberPassword, loginSetting} =this.state.loginstate;
    
    this.loginsetState({ isLogging: true });
    doEvent('beforLogin', () => {
      window.doLoginAction &&
        window.doLoginAction('login', {
          queryParams: WeaTools.getUrlParams ? WeaTools.getUrlParams(locationparams) : queryParams,
          logintype,
          langid: langId,
          loginSetting,
          isRememberAccount,
          isRememberPassword,
          success: (username, password, params = {}) => {
            jQuery.setSessionTimeZone && jQuery.setSessionTimeZone();

            let cacheAccount = '';
            let cachePassword = '';
            if (isRememberAccount) cacheAccount = username;
            if (isRememberPassword) cachePassword = password;
            this.loginsetState({ isRememberAccount, isRememberPassword, cacheAccount, cachePassword });
            initLSValue(username, langId);
            setLSValue('login', 'loginId', username);
            setLSValue('login', 'langId', langId);
            setLSValue('login', 'langText', langText);
            setLSValue('login', 'cacheAccount', cacheAccount);
            setLSValue('login', 'cachePassword', cachePassword);
            setLSValue('login', 'isRememberAccount', isRememberAccount);
            setLSValue('login', 'isRememberPassword', isRememberPassword); 
            window.clearInterval(this.state.dynamicPasswordInterval);
            this.setState({dynamicPasswordTime:0,visible:false})
            this.loginsetState({ isLogging: false });
            window.hasloginpop=false;
          },
          failure: (params = {}) => {
            this.loginsetState({ isLogging: false });
            if (params.reflashValidateCode) {
              this.onValidateCodeChange();
            }
            this.getLoginForm({}, (result = {}) => {
              const { loginSetting = {}, message: warningMsg } = result;
              const { userUsbType } = loginSetting;
              if (userUsbType == '6') {
                warningMsg && message.warning(warningMsg);
                this.setStateAndCache('loginType', 'QRCode');
              }
            });
          },
        });
    });
  }

  onQCLoginStart(cusQrcodeValidTime, cusQrcodeReqTime) {
    this.setState({qrcodeIsInvalid:false})

    const qrcodeValidTime = cusQrcodeValidTime || this.state.qrcodeValidTime;
    const qrcodeReqTime = cusQrcodeReqTime || this.state.qrcodeReqTime;

    let qrcodeUsedTime = 1;
    this.qrcodeCdInterval = window.setInterval(() => {
      if (qrcodeUsedTime >= qrcodeValidTime) {
        this.onQCLoginEnd();
      }
      qrcodeUsedTime++;
    }, 1000);

    this.qrcodeLoginInterval = window.setInterval(() => this.onQCLogin(), qrcodeReqTime * 1000);
  }

  onQCLoginEnd() {
    this.setState({qrcodeIsInvalid:true})
    window.clearInterval(this.qrcodeCdInterval);
    window.clearInterval(this.qrcodeLoginInterval);
  }

  onQCLogin() {
    // 二维码已失效
    if (this.state.qrcodeIsInvalid) return;
    const { langId, langText, qrCode,} = this.state.loginstate;       
    let queryParams = WeaTools.getUrlParams ? WeaTools.getUrlParams(this.state.locationparams) : this.state.queryParams;
    queryParams = toJS(queryParams);
    WeaTools.callApi('/api/hrm/login/qrcode/getQCLoginStatus', 'POST', {
        langid: langId,
        loginkey: qrCode.loginkey,
        isie: ua.browser === 'IE',
        ...queryParams,
      }).then((result) => {
      if (result.status == '1') {
        jQuery.setSessionTimeZone && jQuery.setSessionTimeZone();
        WeaTools.ls.set('languageidweaver', langId);

        setLSValue('login', 'langId', langId);
        setLSValue('login', 'langText', langText);

        // 处理sso 扫码登录
        if (queryParams && queryParams.appid && queryParams.service) {
            queryParams.authenticationType = 2;
            jQuery('body').append("<form name='ssoForm'></form>");
            let form = jQuery("form[name='ssoForm']");
            form.attr('action', '/login/VerifyLoginWeaversso.jsp');
            form.attr('method', 'post');
            form.attr('style', 'display:none');
            for (let key in queryParams) {
                form.append(`<input type='text' name='${key}' value = '${queryParams[key]}'></input>`);
            }
            // 跳转到sso
            form.submit();
            return;
        }
        this.setState({visible:false})
        window.hasloginpop=false;
      }
    });
  }


  render() {
    const {visible, loading, dialoading, updatestatus, casstatus, multiLangs, qrcodeValidTime,afterLoginRenderEventStatus,emobileDownloadUrl,
    qrcodeReqTime, qrcodeIsInvalid, customloading, queryParams, locationparams, loginFormDataLoading, loginstate,dynamicPasswordTime,dynamicPasswordInterval}=this.state;
    const {labelInfo,langId} = loginstate;
    let labelObj=labelInfo[`langid${langId}`] || {};     
    return (
        <WeaDialog
          visible={visible}
          loading={dialoading}
          title={labelObj.loginpoptitle}
          icon="icon-coms-Prompt"
          iconBgcolor="transparent"
          parentClassName="wea-login-pop"
          style={{ width: 450 }}
          zIndex={100}
          closable={false}
          destroyBodyOnClose={true}
        >
        <div className='login-pop-body'>
            <E9Login 
                visible={visible}
                loading={loading}
                dialoading={dialoading}
                updatestatus={updatestatus}
                casstatus={casstatus}
                multiLangs={multiLangs}
                afterLoginRenderEventStatus={afterLoginRenderEventStatus}
                qrcodeValidTime={qrcodeValidTime}
                qrcodeReqTime={qrcodeReqTime}
                qrcodeIsInvalid={qrcodeIsInvalid}
                customloading={customloading}
                queryParams={queryParams}
                locationparams={locationparams}
                loginFormDataLoading={loginFormDataLoading}
                loginstate={loginstate}
                dynamicPasswordTime={dynamicPasswordTime}
                dynamicPasswordInterval={dynamicPasswordInterval}
                emobileDownloadUrl={emobileDownloadUrl}
                getLoginForm={this.getLoginForm}
                loginsetState={this.loginsetState}
                setStateAndCache={this.setStateAndCache}
                doAfterLoginRenderEvent={this.doAfterLoginRenderEvent}
                onPasswordForget={this.onPasswordForget}
                onRememberChange={this.onRememberChange}
                onValidateCodeChange={this.onValidateCodeChange}
                getDynamicPassword={this.getDynamicPassword}
                onLogin={this.onLogin}
                onQCLoginStart={this.onQCLoginStart}
                onQCLoginEnd = {this.onQCLoginEnd}
                onQCLogin ={this.onQCLogin}
                {...this.props}
                />
        </div>
        </WeaDialog>
      );
  }
}
    
export default Index;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-login-pop/index.js